import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Input } from "antd";
import AWS from "aws-sdk";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();
const EditProfile = ({ channelInfo, getInfo, user }) => {
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const originName = channelInfo?.nickname ?? "";
	const [channelProfile, setChannelProfile] = useState({
		channel_name: "",
		together_link: "https://www.dangyoung.com/together",
		youtube_link: "",
		instagram_link: "",
		inquiry_link: "",
	});

	const [photo, setPhoto] = useState({});
	const [photoType, setPhotoType] = useState("");
	const [imgSrc, setImgSrc] = useState(
		`${process.env.REACT_APP_S3_HOST}/image/together/profile_${channelInfo.user_id}.${channelInfo.profile_img_type}`
	);
	const [imgChange, setImgChange] = useState(false);

	const inputRef = useRef(null);

	const [greetingList, setGreetingList] = useState([]);

	useEffect(() => {
		if (channelInfo.nickname) {
			setChannelProfile({
				channel_name: channelInfo.nickname,
				together_link:
					!!channelInfo?.influencer_id &&
					`https://www.dangyoung.com/@${channelInfo?.influencer_id}`,
				youtube_link: channelInfo?.youtube_link,
				instagram_link: channelInfo?.instagram_link,
				inquiry_link: channelInfo?.inquiry_link,
			});
		}
		if (channelInfo.img_type) {
			setPhotoType(channelInfo.profile_img_type);
			setImgSrc(
				`${process.env.REACT_APP_S3_HOST}/image/together/profile_${channelInfo.user_id}.${channelInfo.profile_img_type}`
			);
		}
		if (channelInfo.greetings1) {
			let list = [];
			for (let i = 0; i < 4; i++) {
				if (channelInfo[`greetings${i + 1}`]) {
					list.push(channelInfo[`greetings${i + 1}`]);
				}
			}
			setGreetingList(list);
		}
	}, [channelInfo, user]);

	/**
	 * 프론트 내 업로드 버튼 클릭
	 */
	const onUploadImageClick = () => {
		if (!inputRef.current) {
			return;
		}
		inputRef.current.click();
	};

	/**
	 * 프론트 내 업로드 진행
	 * @param e
	 */
	const onUploadImage = (e) => {
		if (!e.target.files) {
			return;
		}
		const fileList = e.target.files[0];
		const url = URL?.createObjectURL(fileList);
		let photoInfo = {
			file: fileList,
			source: url,
			type: fileList.type,
		};
		setImgChange(true);
		setPhotoType(photoInfo.type?.split("/")[1]);
		setImgSrc(photoInfo.source);
		setPhoto(photoInfo);
		// let photoList = [...reviewPhoto];
		// photoList.push(photoInfo);
		// setReviewPhoto(photoList);
	};

	/**
	 * 프로필 데이터 수정
	 * @param e
	 */
	const handleProfile = (e) => {
		let { name, value } = e.target;
		if (name === "channel_name") {
			setChannelProfile({
				...channelProfile,
				[name]: value,
			});
		} else {
			if (value?.includes("https://")) {
				if (value === "https://") {
					setChannelProfile({
						...channelProfile,
						[name]: "",
					});
				} else {
					setChannelProfile({
						...channelProfile,
						[name]: value,
					});
				}
			} else {
				value = "https://" + value;
				setChannelProfile({
					...channelProfile,
					[name]: value,
				});
			}
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param reviewId
	 */
	const uploadToS3 = async () => {
		let fileType = photo.type?.split("/")[1];
		let s3Path = `image/together/profile_${channelInfo.user_id}.${fileType}`;
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			alert("프로필이 정상적으로 수정되었습니다.");
			getInfo();
			setImgChange(false);
		} else {
			alert("이미지 업로드 오류");
		}
	};

	/**
	 * 링크 복사
	 * @param e
	 */
	const handleCopyLink = (e) => {
		window.navigator.clipboard.writeText(e.currentTarget.value).then(() => {
			alert("링크 복사가 완료 되었습니다.");
		});
	};

	/**
	 * 한 마디 문구 수정
	 * @param e
	 * @param idx
	 */
	const handleGreeting = (e, idx) => {
		let list = [...greetingList];
		list[idx] = e.target.value;
		setGreetingList(list);
	};

	/**
	 * 적용하기 -> 최종 제출
	 * @returns {Promise<void>}
	 */
	const submitEdit = async () => {
		setIsLoading(true);
		let param = {
			...user,
			// 기본 정보
			id: user.id,
			nickname: channelProfile?.channel_name,
			profile_img_type: photoType ? photoType : user?.profile_img_type,
			updated_by: user.id,
			youtube_link: channelProfile?.youtube_link,
			instagram_link: channelProfile?.instagram_link,
			inquiry_link: channelProfile?.inquiry_link,

			// 한 마디 문구
			ingredient_menu_show: channelInfo?.ingredient_menu_show,
			function_menu_show: channelInfo?.function_menu_show,
			combination_menu_show: channelInfo?.combination_menu_show,
			quick_menu_show: channelInfo?.quick_menu_show,
			greetings1: greetingList[0] ?? null,
			greetings2: greetingList[1] ?? null,
			greetings3: greetingList[2] ?? null,
			greetings4: greetingList[3] ?? null,
		};

		// 프로필 이미지, 채널명
		const res = await partnersApi.editProfile(param);
		// 링크
		const rsq = await partnersApi.editUserLink(param);
		// 한 마디 문구
		const rsp = await partnersApi.editGreetings(param);

		if (res.code === 200 && rsq.code === 200 && rsp.code === 200) {
			if (imgChange) {
				uploadToS3();
			} else {
				alert("프로필이 정상적으로 수정되었습니다.");
				getInfo();
				setImgChange(false);
				setIsLoading(false);
			}
		} else {
			if (res.code !== 200) {
				alert("프로필 이미지, 채널명 수정 에러");
			}
			if (rsq.code !== 200) {
				alert("링크 수정 에러");
			}
			if (rsp.code !== 200) {
				alert("한 마디 문구 수정 에러");
			}
			setIsLoading(false);
		}
	};

	return (
		<div style={{ display: "flex", flexDirection: "column" }}>
			<div
				className={`edit-profile-channel`}
				style={{
					alignItems: "flex-start",
				}}
			>
				<div className={`edit-channel-component`}>
					{/* 기본정보 */}
					<Form>
						<div className={`edit-channel-component-body`}>
							<p className={`body-title`}>기본정보</p>
							<div>
								{/* 프로필 이미지 */}
								<Form.Item
									label={`프로필 이미지`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelCol={{ span: 4 }}
									wrapperCol={{ span: 22 }}
									className={`form-with-border profile-form-item`}
								>
									<Button
										className={`edit-profile`}
										onClick={onUploadImageClick}
										disabled={isLoading}
										// style={{
										//     paddingLeft: 0
										// }}
									>
										<input
											type="file"
											accept="image/*"
											style={{
												display: "none",
											}}
											ref={inputRef}
											onChange={onUploadImage}
										/>
										<img
											src={`${imgSrc}`}
											onError={({ currentTarget }) => {
												currentTarget.onerror = null; // prevents looping
												// currentTarget.style.display = "none";
												currentTarget.src = `/assets/images/channel/basic.png`;
											}}
											alt={`채널 이미지`}
											className={`basic-img`}
										/>
										<img
											src={`/assets/images/channel/photo.png`}
											alt={`사진 수정`}
											className={`photo-img`}
										/>
									</Button>
								</Form.Item>

								{/* 채널명 */}
								<Form.Item
									label={`채널명`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelCol={{ span: 4 }}
									wrapperCol={{ span: 14 }}
									className={`form-with-border profile-form-item`}
								>
									<Input
										type={`text`}
										placeholder={`채널명, 닉네임을 입력해주세요.`}
										allowClear={true}
										defaultValue={originName}
										value={channelProfile?.channel_name}
										name={`channel_name`}
										onChange={handleProfile}
										disabled={isLoading}
									/>
								</Form.Item>

								{/* 당영투게더 채널 링크 */}
								<Form.Item
									label={`당영투게더\n채널 링크`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelCol={{ span: 4 }}
									className={`form-with-border profile-form-item`}
								>
									<Input
										type={`text`}
										placeholder={`당영투게더 채널 링크`}
										allowClear={false}
										defaultValue={channelProfile?.together_link}
										value={channelProfile?.together_link}
										disabled={isLoading}
									/>
									<Button
										value={channelProfile?.together_link}
										onClick={handleCopyLink}
										size={`small`}
										style={{
											backgroundColor: "#212529",
										}}
										loading={isLoading}
									>
										<span style={{ color: "white", fontSize: "0.9em" }}>
											링크복사
										</span>
									</Button>
								</Form.Item>

								{/* 유튜브 링크 */}
								<Form.Item
									label={`유튜브 링크`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelCol={{ span: 4 }}
									className={`form-with-border profile-form-item`}
								>
									<Input
										type={`text`}
										placeholder={`유튜브 링크`}
										allowClear={true}
										defaultValue={channelProfile?.youtube_link}
										value={channelProfile?.youtube_link}
										name={`youtube_link`}
										onChange={handleProfile}
										disabled={isLoading}
									/>
								</Form.Item>

								{/* 인스타 링크 */}
								<Form.Item
									label={`인스타 링크`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelCol={{ span: 4 }}
									className={`form-with-border profile-form-item`}
								>
									<Input
										type={`text`}
										placeholder={`인스타 링크`}
										allowClear={true}
										defaultValue={channelProfile?.instagram_link}
										value={channelProfile?.instagram_link}
										name={`instagram_link`}
										onChange={handleProfile}
										disabled={isLoading}
									/>
								</Form.Item>

								{/* 1:1 상담 링크 */}
								<Form.Item
									label={`1:1 상담 링크`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelCol={{ span: 4 }}
									className={`form-with-border profile-form-item`}
								>
									<Input
										type={`text`}
										placeholder={`1:1 상담 링크`}
										allowClear={true}
										defaultValue={channelProfile?.inquiry_link}
										value={channelProfile?.inquiry_link}
										name={`inquiry_link`}
										onChange={handleProfile}
										disabled={isLoading}
									/>
								</Form.Item>
							</div>
						</div>
					</Form>
					{/* 한 마디 문구 수정 */}
					<Form>
						<div className={`edit-channel-component-body`}>
							<p className={`body-title`}>한 마디 문구 수정</p>
							<div>
								{Array.from({ length: 4 })?.map((item, idx) => (
									<Form.Item
										label={`0${idx + 1}`}
										colon={false}
										style={{
											width: "100%",
											margin: 0,
										}}
										labelCol={{ span: 4 }}
										wrapperCol={{ span: 22 }}
										className={`form-with-border profile-form-item`}
									>
										<Input
											type={`text`}
											placeholder={`표기하실 한 마디 문구를 입력해주세요.`}
											allowClear={true}
											defaultValue={item}
											value={greetingList[idx] ?? ""}
											className={`edit-input`}
											onChange={(e) => handleGreeting(e, idx)}
											disabled={isLoading}
										/>
									</Form.Item>
								))}
							</div>
						</div>
					</Form>
				</div>
			</div>

			<Button
				size={"small"}
				className={`edit-success-btn`}
				style={{
					borderRadius: "5px",
					// width: "50%",
					margin: "1em auto",
					padding: "0.3em 1.5em",
					height: "auto",
				}}
				onClick={submitEdit}
				loading={isLoading}
			>
				적용하기
			</Button>
		</div>
	);
};
export default EditProfile;
